module.exports = __webpack_public_path__ + "static/img/guaduan.c6df390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/guaduan.png
// module id = e7Kc
// module chunks = 24